// /accept-invite?token=... (FR-041 to FR-045; SA-AUTH-1).
import { PasswordLinkScreen } from "./PasswordLinkScreen";

export function AcceptInviteScreen() {
  return <PasswordLinkScreen page="invite" />;
}
